module.exports = __webpack_public_path__ + "img/antenna-jqh0GEvuNBY-unsplash.da84a50b.jpg";